<div class="dropdown" [ngStyle]="{'margin-right': fullWidthButton ? '1px' : ''}">
  <button class="btn btn-default dropdown-toggle" role="button" data-toggle="dropdown" [ngClass]="{'btn-block text-left' : fullWidthButton , 'btn-sm': smallButton, 'disabled': isDisabled}">
    <div class="btn-text-ellipse">{{currentDropValue}}</div>
    <b class="caret" [ngClass]="{'caret-right' : fullWidthButton}"></b>
  </button>
  <ul class="dropdown-menu dropdown-height-250" [ngClass]="{'dropdown-menu-width-100' : fullWidthButton}" perfect-scrollbar>
    <ng-container *ngIf="!dropSearch">
      <li *ngFor="let dropValue of dropdownList">
        <a (click)="dropdownChanged(dropValue)">{{dropValue.label}}</a>
      </li>
    </ng-container>
    <li *ngIf="showNoResultsMessage" class="padding-left-base padding-right-base">
      <strong>No results found</strong>
    </li>
  </ul>
</div>
